import { IObject, TSelectedOptions } from '../../../../lib/esm/components/Select/configurations';
import { userSettingsReducerValues, storeUniversalOptions } from '../../UserSettings/reducer';
import { generalReducerValues } from '../../../../General.reducer';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from '../../../../lib/esm/components';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import { IProps } from './interfaces';
import { Wrapper } from './styles';
import { getSettings } from '../../../../tools/getSettings';
import { getStoreMethod } from '../../../../constants/modulesConfig';
import { useWidgetCurrentOptions } from '../../../../tools/useWidgetCurrentOptions';

/**
 * Компонент универсального селетка
 */
const LocationsSelect: React.FC<IProps> = ({
    iconType = 'chevron-down',
    defaultSelected,
    mode = 'multi',
    dropdownAlign = 'left',
    labelText = ' ',
    dropdownWidth,
    outsideText,
    showFilter = false,
    options,
    text,
    minSelected,
    maxSelected,
    name,
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const { locations, selectedLocationId, currentModule } = useSelector(generalReducerValues);
    const { settings, accParamsReceived } = useSelector(userSettingsReducerValues);
    const localCurrentOptions = useWidgetCurrentOptions(currentModule);

    useEffect(() => {
        if (!localCurrentOptions?.currentModule) return;

        const storeMethod = getStoreMethod(localCurrentOptions?.currentModule, name);
        const selectSettings = getSettings(
            settings,
            selectedLocationId,
            localCurrentOptions?.currentModule,
            name,
            storeMethod,
        );
        if (!selectSettings && options?.[0] && selectedLocationId && localCurrentOptions?.currentModule) {
            dispatch(
                storeUniversalOptions({
                    selectedOptions: [options?.[0]],
                    locationId: 1,
                    module: localCurrentOptions?.currentModule,
                    name,
                }),
            );
        }
    }, [localCurrentOptions?.currentModule, mode, name, selectedLocationId]);

    const handleSelect = (args: TSelectedOptions) => {
        selectedLocationId &&
            localCurrentOptions?.currentModule &&
            dispatch(
                storeUniversalOptions({
                    locationId: selectedLocationId,
                    module: localCurrentOptions?.currentModule,
                    selectedOptions: args,
                    name,
                }),
            );
    };

    const outsideSelected =
        (settings['global']?.[name] as TSelectedOptions)?.map((element) => ({
            ...element,
            text: t(element.text || ''),
        })) || [];

    return (
        <Wrapper>
            <Select
                outsideSelected={outsideSelected}
                disabled={locations.length === 0}
                options={
                    options?.map((element) => ({
                        ...element,
                        text: t(element.text || ''),
                    })) as IObject[]
                }
                dropdownWidth={dropdownWidth}
                handleSelect={handleSelect}
                maxSelected={maxSelected}
                minSelected={minSelected}
                labelText={t(labelText)}
                dropdownAlign={dropdownAlign}
                outsideText={accParamsReceived ? outsideText : '-'}
                iconType={iconType}
                showFilter={showFilter}
                mode={mode}
                text={text ? t(text) : t('Selected')}
            />
        </Wrapper>
    );
};

export default LocationsSelect;
